const DOE_PV_BASICS = {
  label: "U.S. Department of Energy — Solar Photovoltaic Technology Basics",
  url: "https://www.energy.gov/cmei/systems/solar-photovoltaic-technology-basics"
};

const DOE_CELL_BASICS = {
  label: "U.S. Department of Energy — Solar Photovoltaic Cell Basics",
  url: "https://www.energy.gov/cmei/systems/solar-photovoltaic-cell-basics"
};

const DOE_EFFICIENCY = {
  label: "U.S. Department of Energy — PV Performance and Efficiency Basics",
  url: "https://www.energy.gov/cmei/systems/solar-photovoltaic-performance-and-efficiency-basics"
};

const DOE_SYSTEM_DESIGN = {
  label: "U.S. Department of Energy — Solar PV System Design Basics",
  url: "https://www.energy.gov/cmei/systems/solar-photovoltaic-system-design-basics"
};

const NREL_EFFICIENCY = {
  label: "NREL — Best Research-Cell Efficiencies",
  url: "https://www.nrel.gov/pv/cell-efficiency.html"
};

const ECOFLOW_DOCS = {
  label: "EcoFlow — Official manuals and documentation",
  url: "https://www.ecoflow.com/support/download/index"
};

export function sourcesForArticle(article = {}) {
  const text = [
    article.title,
    article.target_keyword,
    article.keyword_cluster,
    ...(article.tags || [])
  ].filter(Boolean).join(" ").toLowerCase();

  if (text.includes("ecoflow")) {
    return [ECOFLOW_DOCS, DOE_SYSTEM_DESIGN, DOE_EFFICIENCY];
  }

  if (
    text.includes("efficiency") ||
    text.includes("topcon") ||
    text.includes("perc") ||
    text.includes("monocrystalline") ||
    text.includes("polycrystalline") ||
    text.includes("cell")
  ) {
    return [NREL_EFFICIENCY, DOE_EFFICIENCY, DOE_CELL_BASICS];
  }

  if (
    text.includes("bifacial") ||
    text.includes("rv") ||
    text.includes("van") ||
    text.includes("portable") ||
    text.includes("camping") ||
    text.includes("shed") ||
    text.includes("off-grid") ||
    text.includes("charge controller") ||
    text.includes("voltage")
  ) {
    return [DOE_SYSTEM_DESIGN, DOE_EFFICIENCY, DOE_PV_BASICS];
  }

  return [DOE_PV_BASICS, DOE_EFFICIENCY, DOE_SYSTEM_DESIGN];
}
